import { BackgroundId } from '../../catalog';

import { buildBeach } from './beach';
import { Backdrop } from './common';
import { buildFarm } from './farm';
import { buildSpace } from './space';

export type { Backdrop } from './common';
export { GROUND_Y } from './common';

/** The 3D scene behind the tomato, or null for the plain glow (drawn by the page's CSS). */
export const buildBackdrop = (
    id: BackgroundId,
    dark: boolean,
    farmSign: string
): Backdrop | null => {
    switch (id) {
        case 'beach':
            return buildBeach(dark);
        case 'space':
            return buildSpace(dark);
        case 'farm':
            return buildFarm(dark, farmSign);
        default:
            return null;
    }
};
